import { Component } from 'react';

class SimpleTableComponent extends Component {
    render() {
        let { _pageScope, moduleId, tableType, ...others } = this.props;
        if (tableType === 'simpleTable') {
            return <div className='lowcode-table'> {_pageScope.props.table.createSimpleTable(moduleId ?? others.items?.code, others)} </div>;
        } else {
            return <div className='lowcode-table'> {_pageScope.props.editTable.createEditTable(moduleId ?? others.items?.code, others)}</div>;
        }
    }
}

export default SimpleTableComponent;